import { Collapse, Timeline } from 'antd-v5';
import styled from 'styled-components';
import { Flex } from 'UI';

export const SAntCollapse = styled(Collapse)`
  margin-left: -26px !important;
  .ant5-collapse-content-box {
    padding: 0 !important;
  }
  .ant5-collapse-header {
    padding: 12px 16px 8px 26px !important;
  }
`;

export const SContainer = styled.div`
  background: ${({ theme }) => theme.color.white};
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const SAttachmentContent = styled.div`
  background: ${({ theme }) => theme.color.blue_grey};
  border-radius: 8px;
  padding: 10px;
`;

export const SCommentContent = styled.div`
  background: ${({ theme }) => theme.color.blue_grey};
  border-radius: 8px;
  padding: 10px;
`;

export const SLabelContainer = styled.div<{ maxWidth?: number }>`
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
  max-width: ${({ maxWidth }) => maxWidth ?? 250}px;
`;

export const SFooterButton = styled.div`
  cursor: pointer;
`;

export const STimeline = styled(Timeline)`
  .ant5-timeline-item-last {
    padding-bottom: 0 !important;
  }
`;

export const OriginalContent = styled(Flex)`
  background: ${({ theme }) => theme.color.grey95_light_130};
  border-radius: 8px;
  padding: 10px;
  overflow: hidden;
  word-break: break-word;
`;
